export default __webpack_public_path__ + "static/logo-76a7228c96a4607f8ff515955c665366.png";